class FeedbackError extends Error {
  constructor(
    public readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = 'User feedback';
    Object.setPrototypeOf(this, FeedbackError.prototype);
    if ((Error as any).captureStackTrace) {
      (Error as any).captureStackTrace(this, FeedbackError);
    }
  }
}
export default FeedbackError;
